module.exports = __webpack_public_path__ + "img/fellowfinance.6226d89.png";